(ns portal.login-page.queries
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries.http :as qhttp]))

;; Select fn should be defined with defn so it doesn't
;; change on every render. Or you could also use useCallback.
(defn sso-config-select [data]
  (-> data
      (->clj)
      (update :sso-domains set)))

(defn sso-config-query [url-context]
  #js {:queryKey #js ["login" "sso-config"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/sso-config url-context)
                             {:skip-auth-token true}))
       :select sso-config-select})
